import * as React from "react";

import BaseProductGroupListLayout from "./BaseProductGroupListLayout";

export default function (params) {
  return BaseProductGroupListLayout();
}
